define('util/physics',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.altitudeToPressure = exports.temp = exports.mmAir = exports.lapseRate = exports.temp0 = exports.pressure0 = exports.rho0 = exports.gasConst = exports.gravity = void 0;
    // Physical constants
    exports.gravity = 9.80665; // Acceleration due to gravity (m/s^2)
    exports.gasConst = 8.31447; // Universal gas constant (J/mol/K)
    // ISA standard atmosphere
    exports.rho0 = 1.225; // kg/m^3 ISA density at sea level
    exports.pressure0 = 101325.0; // ISA pressure at sea level Pa
    exports.temp0 = 288.15; // ISA temperature 15 degrees celcius
    exports.lapseRate = 0.0065; // Temperature lapse rate (K/m)
    exports.mmAir = 0.0289644; // Molar mass of dry air (kg/mol)
    // Exponent for barometric formula
    var baroExp = exports.gravity * exports.mmAir / (exports.gasConst * exports.lapseRate);
    /**
     * Temperature in kelvin at a given altitude.
     * https://en.wikipedia.org/wiki/Lapse_rate
     */
    function temp(altitude) {
        return exports.temp0 - exports.lapseRate * altitude;
    }
    exports.temp = temp;
    /**
     * Barometric formula
     * https://en.wikipedia.org/wiki/Atmospheric_pressure#Altitude_variation
     * @return pressure in pascals (Pa)
     */
    function altitudeToPressure(altitude) {
        return exports.pressure0 * Math.pow(1 - exports.lapseRate * altitude / exports.temp0, baroExp);
    }
    exports.altitudeToPressure = altitudeToPressure;
});
//# sourceMappingURL=/assets/javascripts/util/physics.js.map;
